
import Vue from 'vue'
import Newsletter from './newsletter'
import NewsletterItem from './newsletter.vue'
import NewsletterViewer from './newsLetterViewer.vue'

let baseUrl = (window as any).baseUrl

// Summer Activities (only these three)
const summerActivities: Newsletter[] = [
  { imagePath: baseUrl + 'SummerActivities2025_thumbnail.png', pdfPath: baseUrl + '/SummerActivities2025.pdf', title: 'Spring Activities 2025' },
  { imagePath: baseUrl + 'SummerActivities2024_thumbnail.png', pdfPath: baseUrl + '/Summer Activities 2024.pdf', title: 'Summer Activities 2024' },
  { imagePath: baseUrl + 'SummerActivitiesComingSoon2023_thumbnail.png', pdfPath: baseUrl + '/SummerActivitiesComingSoon2023.pdf', title: 'Summer Activities 2023' },
]

// General Newsletters (everything else)
const generalNewsletters: Newsletter[] = [
  { imagePath: baseUrl + '2025SummerThumbnail.png', pdfPath: baseUrl + '/2025SummerNewsletter.pdf', title: 'Summer 2025' },
  { imagePath: baseUrl + 'WinterNewsletter2025_thumbnail.png', pdfPath: baseUrl + '/WinterNewsletter2025.pdf', title: 'Winter 2025' },

  {imagePath: baseUrl + 'FallNewsletter2024_thumbnail.png', pdfPath: baseUrl + '/FallNewsletter2024.pdf', title: 'Fall 2024'},

  {imagePath: baseUrl + 'SummerNewsletter2024_thumbnail.png', pdfPath: baseUrl + '/SummerNewsletter2024.pdf', title: 'Summer 2024'},
  {imagePath: baseUrl + 'Winter24Newsletter_thumbnail.png', pdfPath: baseUrl + '/Winter24Newsletter.pdf', title: 'Winter 2024'},

  {imagePath: baseUrl + 'FallNewsletter2023_thumbnail.png', pdfPath: baseUrl + '/FallNewsletter2023.pdf', title: 'Fall 2023'},
{ imagePath: baseUrl + 'FallNewsletter2022_thumbnail.png', pdfPath: baseUrl + '/FallNewsletter2022.pdf', title: 'Fall 2022' },
  { imagePath: baseUrl + 'SummerNewsletter2022_thumbnail.png', pdfPath: baseUrl + '/SummerNewsletter2022.pdf', title: 'Summer 2022' },
  
  { imagePath: baseUrl + '2022Winter_thumbnail.png', pdfPath: baseUrl + '/2022Winter.pdf', title: 'Winter 2022' },
  { imagePath: baseUrl + 'Fall2021_thumbnail.png', pdfPath: baseUrl + '/fall2021.pdf', title: 'Fall 2021' },
  { imagePath: baseUrl + 'SummerNewsletter2021_thumbnail.png', pdfPath: baseUrl + '/SummerNewsletter2021.pdf', title: 'Summer 2021' },
  
  
  { imagePath: baseUrl + 'FallNewsletter2020_thumbnail.png', pdfPath: baseUrl + '/FallNewsletter2020.pdf', title: 'Winter 2021' },
  
]

export default Vue.extend({
  components: {
    NewsletterItem,
    NewsletterViewer,
  },
  data() {
    return {
      selectedNewsletter: null,
      summerActivities,
      generalNewsletters,
    }
  }
})
